import { Form, Card } from 'react-bootstrap'
import { Text, Number, Email, File, SelectBox } from '../../../input_fields'
import { FormikProvider, useFormik } from 'formik'
import { SaveButton } from '../../../buttons'
import { UpdateProfileSchema } from './ValidationSchema'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Loader } from '../../../loader'
import { updateProfile } from '../../../../redux/slices/users'
import { departmentList } from '../../../../redux/slices/master/department/DepartmentList'
import { designationList } from '../../../../redux/slices/master/designation/DesignationList'
import { addUpdateHandler } from '../../../../utils'
import { toggleUpdateModal, toggleBool } from '../../../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const ProfileImport = {
    Form,
    Card,
    Text,
    Number,
    Email,
    File,
    SelectBox,
    FormikProvider,
    useFormik,
    SaveButton,
    UpdateProfileSchema,
    useNavigate,
    Loader,
    useSelector,
    useDispatch,
    updateProfile,
    departmentList,
    designationList,
    addUpdateHandler,
    toggleUpdateModal,
    toggleBool,
    useTranslation
}